var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 15.1667C4.5333 15.1667 1.71997 12.3467 1.71997 8.88666C1.71997 7.63999 2.08664 6.43332 2.77997 5.39332C2.9333 5.16666 3.24664 5.09999 3.4733 5.25332C3.69997 5.40666 3.76664 5.71999 3.6133 5.94666C3.0333 6.81332 2.72664 7.83332 2.72664 8.87999C2.72664 11.7933 5.0933 14.16 8.00664 14.16C10.92 14.16 13.2866 11.7933 13.2866 8.87999C13.2866 5.96666 10.9133 3.59999 7.99997 3.59999C7.38664 3.59999 6.78664 3.68666 6.21997 3.85999C5.9533 3.93999 5.6733 3.79332 5.5933 3.52666C5.5133 3.25999 5.65997 2.97999 5.92664 2.89999C6.5933 2.69999 7.28664 2.59332 7.99997 2.59332C11.4666 2.59332 14.28 5.41332 14.28 8.87332C14.28 12.3333 11.4666 15.1667 7.99997 15.1667Z",
    fill: "#0098A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24662 4.04668C5.13329 4.04668 5.01329 4.00668 4.91995 3.92668C4.70662 3.74001 4.68662 3.42668 4.86662 3.22001L6.79329 1.00668C6.97329 0.800009 7.29329 0.773343 7.49995 0.960009C7.70662 1.14001 7.72662 1.46001 7.54662 1.66668L5.61995 3.87334C5.51995 3.98668 5.37995 4.04668 5.24662 4.04668Z",
    fill: "#0098A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49338 5.68668C7.39338 5.68668 7.28672 5.65335 7.20005 5.59335L4.94672 3.94668C4.72672 3.78668 4.68005 3.47335 4.84005 3.25335C5.00005 3.02668 5.31338 2.98001 5.54005 3.14001L7.78672 4.78001C8.00672 4.94001 8.06005 5.25335 7.89338 5.48001C7.80005 5.62001 7.64672 5.68668 7.49338 5.68668Z",
    fill: "#0098A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "359376f66953661c140b1f7d8fc84588.svg";
export { ForwardRef as ReactComponent };